import { render, staticRenderFns } from "./activator.vue?vue&type=template&id=2fae0fa4&scoped=true&lang=pug&"
import script from "./activator.ts?vue&type=script&lang=ts&"
export * from "./activator.ts?vue&type=script&lang=ts&"
import style0 from "./activator.vue?vue&type=style&index=0&id=2fae0fa4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae0fa4",
  null
  
)

export default component.exports